import React from 'react';
import { Link } from 'gatsby';
import header from './header.module.scss';

export default () => (
  <nav className={header.nav}>
    <div className={header.nav_wrapper}>
      <Link to="/" className={header.logo}>
        <img
          src="https://locals-house-prod.oss-cn-shenzhen.aliyuncs.com/localhomeqy/official-web/asset/logo.png"
          alt="logo"
        />
      </Link>
      <div className={header.fr_menu}>
        <Link to="/">首页</Link>
        <span
          className={header.msb}
          onClick={() => window.open('https://minsubao.net/')}
        >
          路客云
        </span>
        <span className={header.dropdown}>
          关于我们
          <div className={header.dropdown_list}>
            {/* <Link to="/brand">品牌介绍</Link> */}
            <Link to="/media">媒体报道</Link>
          </div>
        </span>
        <Link to="/lifeHouse">路客生活馆</Link>
        <Link to="/business/">商务合作</Link>
        <Link to="/contact">联系我们</Link>
        <span className={header.dropdown_app}>
          APP
          <div className={header.dropdown_qr}>
            <img
              src="https://locals-house-prod.oss-cn-shenzhen.aliyuncs.com/localhomeqy/official-web/asset/app_erweima.png"
              alt="app-QR"
            />
            <p>下载手机客户端</p>
          </div>
        </span>
        <span className={header.dropdown_wechat}>
          公众号
          <div className={header.dropdown_qr}>
            <img
              src="https://locals-house-prod.oss-cn-shenzhen.aliyuncs.com/localhomeqy/official-web/asset/wechat_erweima.png"
              alt="wechat-QR"
            />
            <p>关注公众号</p>
          </div>
        </span>
      </div>
    </div>
  </nav>
);
